/* EuroVan cart drawer — charte Vanlife (24/09/2026)
   1) « + Ajouter » in "Complete your installation": adds the item and refreshes the drawer.
   2) Checkout: the bundle code reached (VANPACK-10 / VANPACK-15) is passed to checkout, nothing to type. */
(function () {
  if (window.__vpcCart) return; window.__vpcCart = 1;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-vpc-add]');
    if (b) {
      e.preventDefault(); b.setAttribute('aria-busy', 'true');
      fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: +b.getAttribute('data-vpc-add'), quantity: 1 }] }) })
        .then(function () { document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true })); })
        .catch(function () {}).then(function () { b.removeAttribute('aria-busy'); });
      return;
    }
    var c = e.target.closest && e.target.closest('#cart-drawer button[name="checkout"], .cart__summary button[name="checkout"]');
    if (c) {
      var k = document.querySelector('#cart-drawer [data-vpc-code]') || document.querySelector('[data-vpc-code]');
      var terms = document.querySelector('.js-cart-terms-checkbox');
      if (k && !(terms && !terms.checked)) { /* 26/09/2026: pack code is also applied in the cart; kept as a fallback */
        e.preventDefault();
        window.location.href = root + 'checkout?discount=' + encodeURIComponent(k.getAttribute('data-vpc-code'));
      }
    }
  }, true);
})();

/* 24/09/2026 : « Estimer » les frais de livraison dans le panier (mêmes tarifs que la fiche produit).
   Pays mémorisé (même clé que la fiche produit) : l'estimation s'affiche directement la fois suivante. */
(function () {
  if (window.__vpcEst) return; window.__vpcEst = 1;
  var EU = 'AT BE BG HR CZ DK EE FI DE GR HU IE IT LV LT LU MT NL PL PT RO SK SI ES CY SE NO'.split(' ');
  var Z = { FR: { c: 'EUR', t: [999, 1499, 1999], f: 39900 }, CH: { c: 'CHF', t: [1999], f: 39900 }, GB: { c: 'GBP', t: [1999], f: 39900 } };
  EU.forEach(function (k) { Z[k] = { c: 'EUR', t: [1499, 1999, 2499], f: 39900 }; });
  function money(c, cc, lang) {
    var whole = c % 100 === 0;
    if (cc === 'EUR') { var s = (c / 100).toFixed(2).split('.'); return '€' + s[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + (whole ? '' : ',' + s[1]); }
    try { return new Intl.NumberFormat(lang, { style: 'currency', currency: cc, currencyDisplay: 'narrowSymbol', minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: whole ? 0 : 2 }).format(c / 100); } catch (e) { return (c / 100).toFixed(2) + ' ' + cc; }
  }
  function saved() { try { return localStorage.getItem('vpg_ship_cc'); } catch (e) { return null; } }
  function calc(box) {
    var sel = box.querySelector('[data-vpc-est-cc]'), out = box.querySelector('[data-vpc-est-fee]');
    var cc = sel.value, z = Z[cc], cur = box.dataset.cur, lang = box.dataset.lang || 'en';
    var rate = (window.Shopify && Shopify.currency && +Shopify.currency.rate) || 1;
    if (!z) { out.textContent = box.dataset.quote; return; }
    var conv = (z.c === 'EUR' && cur !== 'EUR') ? rate : 1, show = (z.c === 'EUR' || z.c === cur) ? cur : z.c;
    var tot = +box.dataset.tot || 0, totZ = (z.c === cur || z.c === 'EUR') ? tot / conv : tot / rate, w = +box.dataset.w || 0;
    if (totZ >= z.f) { out.textContent = box.dataset.free; return; }
    var fee = z.t[Math.min(z.t.length - 1, w < 7000 ? 0 : (w < 12000 ? 1 : 2))];
    out.textContent = money(Math.round(fee * conv), show, lang);
    var s = sel.parentNode; var cv = calc.c || (calc.c = document.createElement('canvas')), x = cv.getContext('2d'), cs = getComputedStyle(sel);
    x.font = '700 ' + cs.fontSize + ' ' + cs.fontFamily; sel.style.width = Math.ceil(x.measureText(sel.options[sel.selectedIndex].text).width + 20) + 'px';
  }
  function open(box) {
    var sel = box.querySelector('[data-vpc-est-cc]');
    if (!sel.options.length) {
      var dn = null; try { dn = new Intl.DisplayNames([box.dataset.lang || 'en'], { type: 'region' }); } catch (e) {}
      var list = Object.keys(Z), home = box.dataset.cc; if (home && !Z[home]) list.push(home);
      list.map(function (k) { return [k, dn ? dn.of(k) : k]; }).sort(function (a, b) { return a[1].localeCompare(b[1]); })
        .forEach(function (p) { var o = document.createElement('option'); o.value = p[0]; o.textContent = p[1]; sel.appendChild(o); });
      var sv = saved(); sel.value = (sv && list.indexOf(sv) > -1) ? sv : (home && list.indexOf(home) > -1 ? home : 'FR');
    }
    box.querySelector('[data-vpc-est-btn]').hidden = true; box.querySelector('[data-vpc-est-res]').hidden = false; calc(box);
  }
  document.addEventListener('click', function (e) { var b = e.target.closest && e.target.closest('[data-vpc-est-btn]'); if (b) open(b.closest('[data-vpc-est]')); });
  document.addEventListener('change', function (e) {
    var s = e.target.closest && e.target.closest('[data-vpc-est-cc]'); if (!s) return;
    try { localStorage.setItem('vpg_ship_cc', s.value); } catch (x) {} calc(s.closest('[data-vpc-est]'));
  });
  /* the drawer is re-rendered on every cart change: re-open the estimate if a country was already chosen */
  function auto() { if (!saved()) return; document.querySelectorAll('[data-vpc-est]').forEach(function (b) { if (b.querySelector('[data-vpc-est-res]').hidden) open(b); }); }
  var mo = new MutationObserver(function () { clearTimeout(auto.t); auto.t = setTimeout(auto, 50); });
  function init() { var d = document.getElementById('cart-drawer') || document.querySelector('.cart__summary'); if (d) mo.observe(d, { childList: true, subtree: true }); auto(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* 24/09/2026 : « Estimer la livraison » (calculateur du thème) — pays du visiteur présélectionné */
(function () {
  if (window.__vpcCalc) return; window.__vpcCalc = 1;
  document.addEventListener('click', function (e) {
    var s = e.target.closest && e.target.closest('#cart-drawer summary'); if (!s) return;
    setTimeout(function () {
      var sel = s.parentNode.querySelector('.js-country-select'); if (!sel || sel.dataset.vpcSet) return;
      var cc = (window.Shopify && Shopify.country) || ''; var name = '';
      try { name = new Intl.DisplayNames([document.documentElement.lang || 'en'], { type: 'region' }).of(cc); } catch (x) {}
      var o = [].find.call(sel.options, function (op) { return op.textContent.trim() === name; });
      if (o) { sel.value = o.value; sel.dataset.vpcSet = 1; sel.dispatchEvent(new Event('change', { bubbles: true })); }
    }, 150);
  });
})();

/* 04/10/2026 (Isma) : le code du palier atteint (EXTRA-5 dès 699, VANPACK-10 dès 1 499, VANPACK-15 dès 2 499) est appliqué
   automatiquement au panier pour apparaître dans « Vous économisez » et le total. Un code saisi par le client (autre que ces 3) n'est jamais remplacé. */
(function () {
  if (window.__evsAuto) return; window.__evsAuto = 1;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  /* 06/10/2026 (Isma) : promo à 2 paliers — seul le −5 % est géré automatiquement ; VANPACK-10/15, PRO-10/15 et VAN<devise>-10/-15 saisis par un client sont conservés */
  var OURS = ['VANBUILDER-5', 'VANBUILDER-10', 'VANBUILDER-15', 'BUNDLE-5', 'BUNDLE-10', 'BUNDLE-15', 'EXTRA-5', 'EXTRA-5-PL', 'EXTRA-5-HU'], AUTO = /^(VANBUILDER-\d+|VAN[A-Z]{3}-5)$/, busy = false, t;
  function want() { var e = document.querySelector('#cart-drawer [data-evs-autocode]') || document.querySelector('[data-evs-autocode]'); return e ? (e.getAttribute('data-evs-autocode') || '').toUpperCase() : null; }
  function sync() {
    var w = want(); if (w === null || busy) return;
    busy = true;
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      var codes = (c.discount_codes || []).map(function (d) { return String(d.code || '').toUpperCase(); });
      var mine = codes.filter(function (x) { return OURS.indexOf(x) > -1 || AUTO.test(x); }), other = codes.filter(function (x) { return OURS.indexOf(x) < 0 && !AUTO.test(x); });
      if (other.length) return;                                   /* code du client : on n'y touche pas */
      if ((w && mine.length === 1 && mine[0] === w) || (!w && !mine.length)) return;
      var k = 'evsAuto:' + w + ':' + c.original_total_price; try { if (sessionStorage.getItem(k)) return; sessionStorage.setItem(k, '1'); } catch (x) {}
      return fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ discount: w }) })
        .then(function () {
          if (document.querySelector('#cart-drawer [data-evs-autocode]')) document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
          if (/\/cart\/?$/.test(location.pathname)) location.reload();
        });
    }).catch(function () {}).then(function () { busy = false; });
  }
  function later() { clearTimeout(t); t = setTimeout(sync, 400); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', later); else later();
  new MutationObserver(function (m) { for (var i = 0; i < m.length; i++) { var n = m[i].target; if (n.nodeType === 1 && (n.id === 'free-shipping-notice' || (n.closest && n.closest('#cart-drawer')))) { later(); return; } } })
    .observe(document.documentElement, { childList: true, subtree: true });
})();

/* 04/10/2026 (Isma) : lien « Code promo » sur la même ligne que « Vous économisez » (fermé) ; ouvert, le champ s'affiche normalement */
(function () {
  if (window.__evsPromoInline) return; window.__evsPromoInline = 1;
  function place() {
    document.querySelectorAll('#cart-drawer [data-vpc-promo], .cart__summary [data-vpc-promo]').forEach(function (pm) {
      var par = pm.parentElement, lab = par && par.querySelector('.vpc-save .vpc-save__l');
      if (!lab || pm.open || pm.hidden || !lab.offsetParent) { pm.classList.remove('is-inline'); pm.style.left = pm.style.top = ''; return; }
      if (getComputedStyle(par).position === 'static') par.style.position = 'relative';
      pm.classList.add('is-inline');
      var pr = par.getBoundingClientRect(), lr = lab.getBoundingClientRect(), s = pm.querySelector('summary'), sh = s ? s.offsetHeight : pm.offsetHeight;
      var l = Math.round(lr.right - pr.left + 14) + 'px', t = Math.round(lr.top - pr.top + (lr.height - sh) / 2) + 'px';
      if (pm.style.left !== l) pm.style.left = l; if (pm.style.top !== t) pm.style.top = t;
    });
  }
  var q = null; function sch() { if (q) return; q = requestAnimationFrame(function () { q = null; place(); }); }
  document.addEventListener('toggle', function (e) { if (e.target && e.target.matches && e.target.matches('[data-vpc-promo], .vpc-save')) sch(); }, true);
  window.addEventListener('resize', sch);
  new MutationObserver(sch).observe(document.documentElement, { childList: true, subtree: true });
  sch();
})();

/* 06/10/2026 (Isma) : micro-engagement du panier — bouton « Appliquer » : pose le code proposé sur le panier puis rafraîchit le tiroir */
(function () {
  if (window.__evsEg) return; window.__evsEg = 1;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-evs-eg-apply]'); if (!b) return;
    e.preventDefault(); b.setAttribute('aria-busy', 'true');
    fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ discount: b.getAttribute('data-evs-eg-apply') }) })
      .then(function () {
        if (/\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
      }).catch(function () { b.removeAttribute('aria-busy'); });
  });
})();

/* livraison offerte (code FREE-SHIP-399) : carte « Appliquer » ou ligne « appliqué » selon window.__evsFsOn (lu dans /cart.js par evs-ship.js) */
(function () {
  if (window.__evsEgFs) return; window.__evsEgFs = 1; var t;
  function run() {
    var on = !!window.__evsFsOn;
    document.querySelectorAll('[data-evs-eg][data-kind="fs"]').forEach(function (c) { var h = on || c.hasAttribute('data-sup'); if (c.hidden !== h) c.hidden = h; });
    document.querySelectorAll('[data-evs-eg-on="fs"]').forEach(function (r) { if (r.hidden === on) r.hidden = !on; });
  }
  document.addEventListener('evs:fs', run);
  new MutationObserver(function () { clearTimeout(t); t = setTimeout(run, 30); }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
